import { FlyoutMenu } from "@omni/components/components/Navigation/FlyoutMenu/flyoutMenu";
import { cn } from "@omni/utils/styles";

export const Link = () => {
    const { active } = FlyoutMenu.Category.Link.useContext();

    return (
        <FlyoutMenu.Category.Link
            className={cn("tw:text-left", {
                "tw:border-l-5 tw:border-danger tw:bg-grey tw:-indent-1.25 tw:underline":
                    active,
                "tw:hover:no-underline": !active
            })}
        />
    );
};
